/** Spanish (European) UI strings - align keys with `TRANSLATIONS.en` */
const es = {
  menu: {
    home: 'Inicio',
    ourApps: 'Nuestras apps',
    whoWeAre: 'Quiénes somos',
    privacyPolicy: 'Privacidad',
    contactUs: 'Contacto',
    settings: 'Ajustes'
  },
  siteFooter: {
    ariaLabel: 'Pie de página',
    rightsReserved: 'Todos los derechos reservados.'
  },
  home: {
    title: 'Herramientas simples. Progreso real.',
    intro:
      'Creemos que la tecnología debe ser un socio discreto en tu éxito.',
    masterSwedishLabel: 'Domina el sueco:',
    masterSwedishText:
      'Nuestro conjunto de más de 8 apps de idiomas, incluidas TalkSvenska y SWGrammar, ofrece un ecosistema completo para estudiantes y expatriados.',
    simplifyFinancesLabel: 'Simplifica tus finanzas:',
    simplifyFinancesText:
      'Herramientas como BillTracker y Curren$ee te ayudan a controlar tus gastos locales y globales.',
    designedLabel: 'Diseñado para todos:',
    designedText:
      'Desde temporizadores visuales para niños hasta rompecabezas de orden de palabras avanzados: nuestras apps están pensadas para todas las edades y niveles.',
    carouselRegion: 'Destacados de apps ABASHELARI',
    previousImage: 'Imagen anterior',
    nextImage: 'Imagen siguiente',
    howTitle: 'Qué encontrarás en nuestras apps',
    howSubtitle:
      'Aprendizaje de idiomas, claridad financiera y herramientas familiares; cada producto está enfocado y es útil.',
    feature1Title: 'Domina el sueco con un conjunto unificado',
    feature1Desc:
      'SWGrammar, TalkSvenska y las apps SW cubren gramática, vocabulario y frases, con estudio sin conexión que encaja en tu día a día.',
    feature2Title: 'Controla tu dinero más allá de las fronteras',
    feature2Desc:
      'BillTracker y Curren$ee aclaran suscripciones y gastos en las divisas que realmente usas.',
    feature3Title: 'Herramientas tranquilas para niños y el día a día',
    feature3Desc:
      'Juegos de letras, primeras lecturas y utilidades como Time2See, pensadas para la claridad a cualquier edad.',
    appsStripeTitle: 'Nuestras apps',
    appsStripeAria: 'Nuestras apps - pulsa un icono para abrir su página',
    appsStripePrev: 'Desplazar a la izquierda para más apps',
    appsStripeNext: 'Desplazar a la derecha para más apps'
  },
  ourApps: {
    pageTitle: 'Nuestras apps',
    intro:
      'Desde sueco y lectura lúdica hasta utilidades cotidianas: todo lo que publicamos está aquí. Elige una app para leer la historia, ver capturas y ir al App Store cuando quieras.',
    readMore: 'Leer más',
    downloadLabel: 'Descargar en el App Store',
    appNotFound: 'App no encontrada.',
    screenshotsHeading: 'Capturas y vídeo',
    descriptionMore: 'Más',
    descriptionLess: 'Menos',
    noScreenshotsLead: 'Aún no hay capturas. Añade 3 imágenes en'
  },
  whoWeAre: {
    title: 'Herramientas inteligentes para mentes curiosas.',
    intro:
      'ABASHELARI crea apps enfocadas: aprendizaje del sueco, lectura y juegos para niños, y herramientas prácticas para cada día. Así encaja nuestro trabajo.',
    section1Title: 'Aprendizaje del sueco',
    section1Text:
      'La familia «SW»: SWGrammar, SWVerbs, SWVocabulary, SWWorder, SWAdjective y TalkSvenska forma un ecosistema para quien aprende sueco: práctica estructurada, explicaciones claras, audio donde importa y flujos sin conexión para que estudiar encaje en la vida real.',
    section2Title: 'Juegos para niños: inglés y hebreo',
    section2Text:
      'También creamos juegos visuales y calmados para primeros lectores: trazado de letras, letras y palabras, y vocabulario adaptado al inglés y al hebreo. Pantalla con sentido: repetición que entienden los niños, diseño legible y progresión respetuosa.',
    section3Title: 'Utilidades del día a día',
    section3Text:
      'Además de la educación, ofrecemos utilidades para rutinas cotidianas. BillTracker ayuda a seguir facturas y suscripciones, con vistas multi-divisa cuando la vida cruza fronteras. Curren$ee hace entendible el gasto en las divisas que te importan. Time2See ofrece temporizadores visuales para los niños. Cada producto busca rapidez y claridad.',
    section4Title: 'Quiénes somos y qué buscamos',
    section4Text:
      'ABASHELARI es un pequeño estudio independiente. Priorizamos pulido y privacidad frente a monetización agresiva: interfaces limpias y respeto por tu atención y tus datos. Creamos herramientas concretas -dominar sueco, apoyar los primeros pasos en la lectura o mantener legible el dinero del hogar- y las mejoramos según el uso real.'
  },
  contact: {
    title: 'Contacto',
    p1:
      '¿Una pregunta o una sugerencia, o solo quieres saludar? Somos un estudio pequeño y leemos todos los mensajes. Lo más rápido es escribirnos por correo:',
    p2:
      'También puedes usar el formulario de abajo: como prefieras. Responderemos lo antes posible.',
    p3: 'Gracias por escribirnos.',
    name: 'Nombre',
    emailLabel: 'Correo electrónico',
    message: 'Mensaje',
    messageErrorMin: 'Escribe al menos 10 caracteres en tu mensaje.',
    messageErrorMax: 'Tu mensaje puede tener como máximo 500 caracteres.',
    submitSending: 'Enviando…',
    submitSuccess:
      '¡Gracias! Tu mensaje se ha enviado; te responderemos pronto.',
    submitError:
      'No se pudo enviar el mensaje. Inténtalo de nuevo o escríbenos por correo.',
    gotIt: 'Entendido',
    send: 'Enviar mensaje'
  },
  settings: {
    title: 'Ajustes',
    languageTitle: 'Idioma',
    languageDesc: 'Elige el idioma de todo el sitio.',
    english: 'Inglés',
    swedish: 'Sueco',
    spanish: 'Español',
    german: 'Alemán',
    french: 'Francés'
  },
  privacy: {
    title: 'Política de privacidad',
    updated: 'Última actualización: 3 de marzo de 2025',
    intro:
      'Esta política describe cómo ABASHELARI recopila, usa, almacena y protege la información cuando usas nuestra web y nuestras apps móviles.',
    contactHeading: 'Contacto',
    contactTextLead: '¿Dudas sobre privacidad? Escríbenos a',
    contactTextTrail: '.',
    collectHeading: 'Información que podemos recopilar',
    collectIntro:
      'Según el producto, podemos recopilar información limitada necesaria para el servicio, soporte y fiabilidad.',
    collectItems: [
      'Datos de contacto que facilites (por ejemplo, correo al contactarnos).',
      'Datos de uso y diagnóstico generados por la app o la web (por ejemplo, informes de errores o métricas).',
      'Información técnica del dispositivo que envían apps y navegadores (tipo de dispositivo, SO y ubicación general por IP cuando aplique).'
    ],
    useHeading: 'Cómo usamos la información',
    useItems: [
      'Para prestar, mantener y mejorar nuestras apps y la web.',
      'Para responder a soporte y comunicar actualizaciones importantes.',
      'Para entender tendencias agregadas y corregir errores (minimizando datos personales cuando sea posible).'
    ],
    shareHeading: 'Compartición y encargados',
    shareText:
      'No vendemos tus datos personales. Podemos compartir información con proveedores que nos ayudan a operar el servicio (alojamiento, analítica, correo), con salvaguardas y solo cuando sea necesario.',
    retentionHeading: 'Conservación',
    retentionText:
      'Conservamos la información solo el tiempo necesario para los fines de esta política, salvo obligación legal de conservarla más tiempo.',
    securityHeading: 'Seguridad',
    securityText:
      'Aplicamos medidas razonables para proteger la información, pero ningún método de transmisión o almacenamiento es 100 % seguro.',
    childrenHeading: 'Privacidad infantil',
    childrenText:
      'Nuestras apps pueden ser aptas para familias. Si crees que un menor ha facilitado datos sin consentimiento adecuado, contáctanos y tomaremos medidas razonables para borrarlos cuando corresponda.',
    thirdHeading: 'Enlaces a otros sitios',
    thirdText:
      'Nuestra web o apps pueden enlazar sitios de terceros (por ejemplo, App Store). Esos sitios tienen sus propias políticas.',
    changesHeading: 'Cambios',
    changesText:
      'Podemos actualizar esta política ocasionalmente. Cuando lo hagamos, actualizaremos la fecha de «Última actualización» y publicaremos la revisión.',
    rightsHeading: 'Tus opciones',
    rightsText:
      'Según tu lugar de residencia, puedes tener derechos de acceso, rectificación o supresión de ciertos datos. Escríbenos y responderemos en un plazo razonable.'
  }
};

export default es;
